// Known demo tenant userIds. These maps are marketing surfaces, not real
// customer data — they're linked from the landing pages' "View live example"
// CTAs and used to show off the product. Treat them as promotable surfaces
// (e.g. the demo-map signup banner) rather than private customer maps.
export const DEMO_ACCOUNT_IDS = [
  '6a11a0d03fa20b7ef54349c2', // primary public demo (landing "View live example")
  '69c99b038de5d9ac4a25c3a9', // seeded UK-solar demo
] as const;

// The primary public demo tenant — linked from landing pages' "View live
// example" CTAs and embedded on the /maps/* demo pages.
export const PRIMARY_DEMO_ACCOUNT_ID = DEMO_ACCOUNT_IDS[0];

export const isDemoAccount = (userId?: string): boolean =>
  !!userId && (DEMO_ACCOUNT_IDS as readonly string[]).includes(userId);
